module.exports = __webpack_public_path__ + "static/media/chef_lady.5cbb520d.png";